import 'sass/app.scss';

import _ from 'lodash';
import React, {useState} from 'react';
import { Link } from 'react-router-dom';

const Welcome = () => {
    const [fanHover, setfanHover] = useState(false);
    const [artHover, setartHover] = useState(false);
    const [loginHover, setloginHover] = useState(false);
    return (
        <div id="section-1" className="segment-1 " style={{'backgroundColor': 'white'}}>
            <div className="mzd-trapezoid">
                <div className="grid-x align-top align-spaced">
                    <div className="columns">
                        <div className="w-logo"></div>
                        <p className="wumbo-2 welcome-title">Own Your Music.</p>

                    </div>
                </div>
            </div>
            <div className="bg-container">
                <div className="welcome-btns" style={{display:'flex'}} >
                    <Link to="/artists" className="welcome-artists">
                        <div>
                            <button className="big-button button margin-top-1" onMouseEnter={() => {setartHover(true)}} onMouseLeave={() => {setartHover(false)}}>
                                Muzado for Artists
                            </button>
                            <div className={`popup-text ${artHover ? 'shown' : ''}`}>You know your worth, and so do we.</div>
                        </div>
                    </Link>
                    <a href="/login" className="welcome-login">
                        <div>
                            <button className="big-button clear-btn button margin-top-1" onMouseEnter={() => {setloginHover(true)}} onMouseLeave={() => {setloginHover(false)}}>
                                Login
                            </button>
                            <div className={`popup-text ${loginHover ? 'shown' : ''}`}>Continue exploring.</div>
                        </div>
                    </a>
                    <Link to="/fans" className="welcome-fans">
                        <div>
                            <button className="big-button button margin-top-1" onMouseEnter={() => {setfanHover(true)}} onMouseLeave={() => {setfanHover(false)}}>
                                Muzado for Fans
                            </button>
                            <div className={`popup-text ${fanHover ? 'shown' : ''}`}>The way music used to be, reimagined.</div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}
export class LandingSelect extends React.Component {
	constructor (props) {
		super(props);
	}

	render() {
			// return <ArtistSignUpForm />;


		return (
			<div>
                <Welcome/>
            </div>
		);
	}
}

export default LandingSelect;
